import { Record as record } from 'immutable';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';

import { isImmutable } from '../../helpers/Immutable';

export const defaults = {
    id: uuidv4(),
    tripId: null,
    orderTripId: null,
    journeyId: null,
    departureDate: moment(),
    outwardJourney: {},
    returnJourney: {},
    outwardEnabled: true,
    returnEnabled: true,
};

class AssistedTravel extends record(defaults) {
    hasJourney(journey) {
        return Boolean(Object.keys(isImmutable(journey) ? journey.toJS() : journey).length);
    }

    removeOutwardJourney() {
        return this.set('outwardJourney', {});
    }

    removeReturnJourney() {
        return this.set('returnJourney', {});
    }

    setOutwardEnabled(enabled) {
        return this.set('outwardEnabled', enabled);
    }

    setReturnEnabled(enabled) {
        return this.set('returnEnabled', enabled);
    }

    hasOutwardJourney () {
        return this.hasJourney(this.outwardJourney);
    }

    hasReturnJourney () {
        return this.returnJourney && Boolean(Object.keys(this.returnJourney).length);
    }

    getOutwardArrivalMoment() {
        return moment(this.outwardJourney.arrivalDate, 'DD/MM/YYYY')
            .set({ hour: this.outwardJourney.arrivalHour, minute: this.outwardJourney.arrivalMinutes });
    }

    getReturnDepartureMoment() {
        return moment(this.returnJourney.departureDate, 'DD/MM/YYYY')
            .set({ hour: this.returnJourney.departureHour, minute: this.returnJourney.departureMinutes });
    }

    getJourneyDepartureMoment(journey) {
        return moment(journey.departureDate, 'DD/MM/YYYY')
            .set({ hour: journey.departureHour, minute: journey.departureMinutes });
    }

    getJourneyArrivalMoment(journey) {
        return moment(journey.arrivalDate, 'DD/MM/YYYY')
            .set({ hour: journey.arrivalHour, minute: journey.arrivalMinutes });
    }

    getFormatedDepartureDate() {
        return this.departureDate.format('D MMMM YYYY');
    }
}

export default AssistedTravel;
